export function getMutationErrorMessage(error: unknown, fallback: string): string {
  if (error && typeof error === 'object' && 'data' in error) {
    const data = (error as { data?: { message?: string; detail?: string } }).data;
    if (data?.message && typeof data.message === 'string') return data.message;
    if (data?.detail && typeof data.detail === 'string') return data.detail;
  }
  if (error instanceof Error) return error.message;
  return fallback;
}

export function isForbiddenError(error: unknown): boolean {
  return (
    typeof error === 'object' &&
    error !== null &&
    'status' in error &&
    (error as { status?: unknown }).status === 403
  );
}

const asRecord = (value: unknown): Record<string, unknown> | null =>
  typeof value === 'object' && value !== null ? (value as Record<string, unknown>) : null;

export function getNumericStatus(error: unknown): number | undefined {
  const status = asRecord(error)?.status;
  return typeof status === 'number' ? status : undefined;
}

/**
 * The backend reports a machine-readable code in two shapes: route errors carry
 * `{ detail: { error } }`, the global exception handlers carry a top-level `{ error }`.
 */
export function getBackendErrorCode(error: unknown): string | null {
  const data = asRecord(asRecord(error)?.data);
  const candidates = [asRecord(data?.detail)?.error, data?.error, data?.error_code];
  return candidates.find((c): c is string => typeof c === 'string' && c.length > 0) ?? null;
}
